import { Directive } from '@angular/core';

@Directive({
    selector: '[appDialogFooter]',
    standalone: false
})
export class DialogFooterDirective {}
